function normalizedFactors(factors) {
    const normalized = [1, 1, 1];
    for (let axis = 0; axis < 3; axis++) {
        const factor = Math.floor(factors?.[axis]);
        normalized[axis] = Number.isFinite(factor) ? Math.max(1, factor) : 1;
    }
    return normalized;
}
function reducedDimensions(sourceDimensions, factors) {
    const boxes = normalizedFactors(factors);
    const dimensions = [1, 1, 1];
    for (let axis = 0; axis < 3; axis++) {
        dimensions[axis] = Math.max(1, Math.ceil(sourceDimensions[axis] / boxes[axis]));
    }
    return dimensions;
}
export { reducedDimensions as default, reducedDimensions, normalizedFactors };
